import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { environment } from "src/environments/environment";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { ForgotPasswordLayoutComponent } from "./containers/forgot-password-layout/forgot-password-layout.component";
import { LoginLayoutComponent } from "./containers/login-layout/login-layout.component";
import { LoggedInGuard } from "./domain/security/loggedin.guard";

const routes: Routes = [
	{
		path: "",
		redirectTo: "login",
		pathMatch: "full"
	},
	{
		path: "",
		component: DefaultLayoutComponent,
		children: [
			{
				path: "home",
				loadChildren: () => import("./pages/home/home.module").then(m => m.HomeModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "not-found",
				loadChildren: () => import("./pages/not-found/not-found.module").then(m => m.NotFoundModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "meu-perfil",
				loadChildren: () => import("./pages/meu-perfil/meu-perfil.module").then(m => m.MeuPerfilModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "tomador",
				loadChildren: () => import("./pages/taker/taker.module").then(m => m.TakerModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "segurado",
				loadChildren: () => import("./pages/insured/insured.module").then(m => m.InsuredModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "ccg-tomador",
				loadChildren: () => import("./pages/ccg-taker/ccg-taker.module").then(m => m.CCGTakerModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "parametros",
				loadChildren: () => import("./pages/parameters/parameters.module").then(m => m.ParametersModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "auditoria",
				loadChildren: () => import("./pages/audit/audit.module").then(m => m.AuditModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "perfil-acesso",
				loadChildren: () => import("./pages/access-profile/access-profile.module").then(m => m.AccessProfileModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "usuario",
				loadChildren: () => import("./pages/user/user.module").then(m => m.UserModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "propostas",
				loadChildren: environment.maintenanceMode
					? () => import("./pages/maintenance/maintenance.module").then(m => m.MaintenanceModule)
					: () => import("./pages/proposals/proposals.module").then(m => m.ProposalsModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "propostas-adiantamento",
				loadChildren: environment.maintenanceMode
					? () => import("./pages/maintenance/maintenance.module").then(m => m.MaintenanceModule)
					: () =>
							import("./pages/proposal-adiantamento/proposal-adiantamento.module").then(
								m => m.ProposalAdiantamentoModule
							),
				canLoad: [LoggedInGuard]
			},
			{
				path: "estrutura-comercial",
				loadChildren: () =>
					import("./pages/commercial-structure/commercial-structure.module").then(m => m.CommercialStructureModule),
				canLoad: [LoggedInGuard]
			},
			{
				path: "pagina-externa/:externalPageUrl",
				loadChildren: () => import("./pages/external-page/external-page.module").then(m => m.ExternalPageModule),
				canLoad: [LoggedInGuard]
			}
		]
	},
	{
		path: "",
		component: LoginLayoutComponent,
		children: [
			{
				path: "login",
				loadChildren: environment.maintenanceMode
					? () => import("./pages/maintenance/maintenance.module").then(m => m.MaintenanceModule)
					: () => import("./pages/login/login.module").then(m => m.LoginModule),
				resolve: {
					url: "UrlRedirectResolver"
				},
				data: {
					urlFront: environment.urlFront
				}
			}
		]
	},
	{
		path: "",
		component: ForgotPasswordLayoutComponent,
		children: [
			{
				path: "esqueci-senha",
				loadChildren: environment.maintenanceMode
					? () => import("./pages/maintenance/maintenance.module").then(m => m.MaintenanceModule)
					: () => import("./pages/forgot-password/forgot-password.module").then(m => m.ForgotPasswordModule)
			}
		]
	},
	{
		path: "",
		component: ForgotPasswordLayoutComponent,
		children: [
			{
				path: "recuperar-senha/:token",
				loadChildren: environment.maintenanceMode
					? () => import("./pages/maintenance/maintenance.module").then(m => m.MaintenanceModule)
					: () => import("./pages/recover-password/recover-password.module").then(m => m.RecoverPasswordModule)
					
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload", preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
